// extracted by mini-css-extract-plugin
export var container = "styles-module--container--db8e2";
export var filled = "styles-module--filled--c09d7";
export var flex = "styles-module--flex--e1837";
export var icon = "styles-module--icon--a01e9";
export var left = "styles-module--left--f963f";
export var outline = "styles-module--outline--b0359";
export var right = "styles-module--right--11958";